/**
 * "SÓ A JANELA ORIGINAL" (13/10/2026) — a escolha de quem lê os relatórios: deixar de fora as tentativas feitas
 * depois de o professor REABRIR o simulado. A regra e a cláusula são do servidor (`filtroDeReabertas.ts`); aqui
 * mora só a escolha, que viaja em todo pedido como `?semReabertas=1` (o `if` é o interceptador de `api.ts`).
 *
 * Fica na SESSÃO do navegador, e não guardada para sempre: quem volta outro dia começa vendo tudo — o padrão é
 * o relatório de sempre, e um filtro esquecido ligado faria o número mudar sem ninguém saber por quê.
 */
const CHAVE = 'relatorios:so-janela-original';

export function soJanelaOriginalLigado(): boolean {
  try { return sessionStorage.getItem(CHAVE) === '1'; } catch { return false; }
}
export function ligarSoJanelaOriginal(ligado: boolean): void {
  try { if (ligado) sessionStorage.setItem(CHAVE, '1'); else sessionStorage.removeItem(CHAVE); } catch { /* sem armazenamento: fica desligado */ }
}
